function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import debounce from "../utils/debounce";
import whenPropertyIsSet from "../utils/whenPropertyIsSet";
import logger, { LapelError } from "../logger";
var beaconEventName = "lapel-ab-track";
var beaconCache = {};
var getAppMeasureScript = function() {
    return whenPropertyIsSet(global, "s", 2000);
};
var sendBeacon = debounce(function() {
    // Store state
    var override = _extends({}, beaconCache, {
        linkTrackVars: Object.keys(beaconCache).join(",")
    });
    beaconCache = {};
    getAppMeasureScript().then(function(appMeasurement) {
        return requestIdleCallback(function() {
            // Using request idle callback makes sure the browser isn't doing much when we send this track
            // Calling tl directly instead of letting launch handle it, because it seems to be asynchronous
            // https://docs.adobe.com/content/help/en/analytics/implementation/vars/functions/tl-method.html
            appMeasurement.tl(true, "o", beaconEventName, override);
        });
    }).catch(function(error) {
        logger.error(new LapelError("App Measure failed", {
            cause: error
        }));
    });
}, function(wait) {
    if (wait === null) return 500.0;
    return wait * 0.5;
});
var measureRenderedMbox = function(param) {
    var evar = param.evar, value = param.value;
    beaconCache[evar] = value;
    sendBeacon();
    return null;
};
export { getAppMeasureScript, measureRenderedMbox };

//# sourceMappingURL=appMeasure.js.map